var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"empty component"},[_c('img',{attrs:{"src":_vm.imageSrc,"alt":"empty"}}),_c('p',{staticClass:"message text-sub-color"},[_vm._v(_vm._s(_vm.displayText))])])
}
var staticRenderFns = []

export { render, staticRenderFns }